export var escapeRegExpString = function (string) { return string.replace(/[\\^$.|?*{}+()[\]]/g, '\\$&'); };
export var DEFAULT_MAX_WIDTH_TOOLTIP = '720px';
//# sourceMappingURL=helpers.js.map